import { message } from 'ant-design-vue';

// time是停留时间
function closeMes(time) {
  return setTimeout(() => {
    message.destroy();
  }, time);
}
export default closeMes